import schemaParser from './schemaParser';
export { schemaParser };
//# sourceMappingURL=index.js.map